import { useQueryClient } from '@tanstack/react-query';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { type Menu } from 'hb-react/types';

// Helper hook to get the topic id from the context or the parameter.
export const useTopicId = (topicIdParam?: number): number | undefined => {
  const { topic: contextTopic, topicId: contextTopicId } = useTopicContext();

  // @ts-expect-error untyped context value
  return topicIdParam || contextTopicId || contextTopic?.id;
};

// Select the global menu or the menu of the topic if in the context of topic.
export const useGlobalOrTopicMenu = (topicId?: number): Menu | undefined => {
  const { currentNetwork } = useDefaultAppContexts();
  const queryClient = useQueryClient();

  if (topicId) {
    return queryClient.getQueryData<Menu>(['topic', topicId, 'menu']);
  }

  // The key must be in sync with app/assets/javascripts/react/shared/hooks/useFetchAppPages/index.js
  return (
    currentNetwork?.app_pages || queryClient.getQueryData<Menu>(['appPages'])
  );
};
